import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useTwilioConversationCallbacks } from '../../session/chat/useTwilioConversationCallbacks';
import { useDisconnectRoomCallback } from '../../session/useDisconnectRoomCallback';
import { activeConversationSidAtom, sessionAppointmentShortIdAtom } from '../state';

export function useVisitorDisconnectRoomCallback() {
  const disconnectRoom = useDisconnectRoomCallback();
  const setSessionConversationSid = useSetAtom(activeConversationSidAtom);
  const setSessionAppointmentShortId = useSetAtom(sessionAppointmentShortIdAtom);
  const getSessionConversationSid = useAtomCallbackMemoized((get) => get(activeConversationSidAtom), []);
  const { leaveConversation } = useTwilioConversationCallbacks();

  return useCallback(
    async () => {
      const room = await disconnectRoom();
      const conversationSid = getSessionConversationSid();
      // attempt to leave the session conversation gracefully as a side effect
      if (conversationSid) {
        leaveConversation(conversationSid);
      }
      setSessionConversationSid(undefined);
      setSessionAppointmentShortId(undefined);
      return room;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
